/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.pos.create.pages.forms.tile.controllers', [
  'acme.common.service.api',
  'acme.common.service.posConfig',
  'acme.common.directive.posTile'
])

.controller('PosCreatePagesFormsTileController', ['$scope', 'ApiService', 'PosConfigService', function($scope, ApiService, PosConfigService) {

    $scope.posCreatePagesFormsTile = {

      model: {}, // tile

      allowNavigationTiles: true,
      selected: {
        type: false
      },

      // tile options
      tiles: {
        generalAdmission: [
          {
            "id":"54a1a3c47d84d983f315a0d8",
            "icon":"none",
            "name":"General Admission",
            "subTitle":"Ticket type",
            "x":0,
            "y":0,
            "type":"rollup",
            "showCapacity":true,
            "price":0.00,
            "presell":{
              "date":"2015-06-25"
            },
            "color":{
              "r":255,
              "g":70,
              "b":70,
              "a":1
            },
            "config":{
              "x":1,
              "y":1,
              "type":"generalAdmission"
            }
          }
        ],
        standard: [
          {
            "id":"54a1a3c47d84d983f315a0d8",
            "icon":"none",
            "name":"Event Name",
            "subTitle":"Ticket type",
            "x":0,
            "y":0,
            "type":"rollup",
            "showCapacity":true,
            "presell":{
              "date":"2015-06-25"
            },
            "color":{
              "r":227,
              "g":174,
              "b":81,
              "a":1
            },
            "config":{
              "x":1,
              "y":1,
              "type":"standard"
            }
          }
        ],
        addon: [
          {
            "id":"54a1a3c47d84d983f315a0d8",
            "icon":"none",
            "name":"Addon",
            "subTitle":"",
            "x":0,
            "y":0,
            "type":"rollup",
            "price":0.00,
            "showCapacity":false,
            "color":{
              "r":113,
              "g":81,
              "b":227,
              "a":1
            },
            "config":{
              "x":0,
              "y":0,
              "type":"addon"
            }
          }
        ],
        navigation: [
          {
            "id":"54a1a3c47d84d983f315a0d8",
            "icon":"none",
            "name":"Navigation",
            "subTitle":"",
            "x":0,
            "y":0,
            "type":"rollup",
            "showCapacity":false,
            "color":{
              "r":81,
              "g":227,
              "b":174,
              "a":1
            },
            "config":{
              "x":0,
              "y":0,
              "type":"navigation"
            }
          }
        ],
        membership: [
          {
            "id":"54a1a3c47d84d983f315a0d8",
            "icon":"none",
            "name":"Membership",
            "subTitle":"",
            "x":0,
            "y":0,
            "type":"rollup",
            "showCapacity":false,
            "color":{
              "r":50,
              "g":205,
              "b":50,
              "a":1
            },
            "config":{
              "x":0,
              "y":0,
              "type":"membership"
            }
          }
        ],
        donation: [
          {
            "id":"54a1a3c47d84d983f315a0d8",
            "icon":"none",
            "name":"Donation",
            "subTitle":"",
            "x":0,
            "y":0,
            "type":"rollup",
            "showCapacity":false,
            "color":{
              "r":50,
              "g":153,
              "b":205,
              "a":1
            },
            "config":{
              "x":0,
              "y":0,
              "type":"donation"
            }
          }
        ]
      },

      init: function() {
        $scope.$on('PosCreatePagesFormsController::Update', this.onPosCreatePagesFormsControllerUpdate);
        $scope.$on('$destroy', this.onDestroy);
      },

      isType: function(type) {
        return (this.selected.type === type);
      },

      checkPages: function() {
        return (PosConfigService.pages.getModel().length > 1);
      },

      select: function(type) {
        if (type) {
          this.selectType(type);
        }
        if (this.selected.type) {
          if (this.selected.type !== 'navigation' ||
              this.selected.type === 'navigation' && this.allowNavigationTiles) {
            this.model.config.type = this.selected.type;
            this.model.color = this.tiles[this.model.config.type][0].color;
            $scope.$emit('PosCreatePagesFormsTileController::Select', this.model);
          }
        }
      },

      selectType: function(type) {
        this.selected.type = type;
      },

      cancel: function() {
        this.selected.type = false;
        this.model.config.type = "tile";
        $scope.$emit('PosCreatePagesFormsTileController::Cancel', this.model);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPosCreatePagesFormsControllerUpdate: function(e, data) {
        var self = $scope.posCreatePagesFormsTile;
        if (data.config.type === 'tile') {
          // do something
          self.model = data;
          self.allowNavigationTiles = self.checkPages();
        }
      },

      onDestroy: function() {
        $scope.posCreatePagesFormsTile.selected = { type: false };
      }

    };

    $scope.posCreatePagesFormsTile.init();

}]);